import { useSelectCurrentOrder } from '../../../../../selectors/order/selectCurrentOrder';
import { useUpdateOrderTimberHook } from '../../../../../API/order/useUpdateOrderHook';
import { IUpdateOrderPatchRequest } from '../../../../../ui-toolkit/orders/interfaces/IUpdateOrderPatchRequest';

export const useUpdateOrderFromSummaryItem = () => {
  const { data: order } = useSelectCurrentOrder();
  const { action: doPatchOrderAction } = useUpdateOrderTimberHook();

  const onPatchOrderInformation = async (updateData: Partial<IUpdateOrderPatchRequest>) => {
    await doPatchOrderAction(order, updateData);
  };

  return { order, onPatchOrderInformation };
};
